export const WareHouseActionTypes = {
    WAREHOUSE_DATA_FIRST: '@@auth/WAREHOUSE_DATA_FIRST',
    WAREHOUSE_DATA_LOADING: '@@auth/WAREHOUSE_DATA_LOADING',
    WAREHOUSE_DATA_SUCCESS: '@@auth/WAREHOUSE_DATA_SUCCESS',
    WAREHOUSE_DATA_ERROR: '@@auth/WAREHOUSE_DATA_ERROR',

    CREATE_WAREHOUSE_DATA_FIRST: '@@auth/CREATE_WAREHOUSE_DATA_FIRST',
    CREATE_WAREHOUSE_DATA_LOADING: '@@auth/CREATE_WAREHOUSE_DATA_LOADING',
    CREATE_WAREHOUSE_DATA_SUCCESS: '@@auth/CREATE_WAREHOUSE_DATA_SUCCESS',
    CREATE_WAREHOUSE_DATA_ERROR: '@@auth/CREATE_WAREHOUSE_DATA_ERROR',

    UPDATE_WAREHOUSE_DATA_FIRST: '@@auth/UPDATE_WAREHOUSE_DATA_FIRST',
    UPDATE_WAREHOUSE_DATA_LOADING: '@@auth/UPDATE_WAREHOUSE_DATA_LOADING',
    UPDATE_WAREHOUSE_DATA_SUCCESS: '@@auth/UPDATE_WAREHOUSE_DATA_SUCCESS',
    UPDATE_WAREHOUSE_DATA_ERROR: '@@auth/UPDATE_WAREHOUSE_DATA_ERROR',

    DELETE_WAREHOUSE_DATA_FIRST: '@@auth/DELETE_WAREHOUSE_DATA_FIRST',
    DELETE_WAREHOUSE_DATA_LOADING: '@@auth/DELETE_WAREHOUSE_DATA_LOADING',
    DELETE_WAREHOUSE_DATA_SUCCESS: '@@auth/DELETE_WAREHOUSE_DATA_SUCCESS',
    DELETE_WAREHOUSE_DATA_ERROR: '@@auth/DELETE_WAREHOUSE_DATA_ERROR',

    UPLOAD_WAREHOUSE_DATA_FIRST: '@@auth/UPLOAD_WAREHOUSE_DATA_FIRST',
    UPLOAD_WAREHOUSE_DATA_LOADING: '@@auth/UPLOAD_WAREHOUSE_DATA_LOADING',
    UPLOAD_WAREHOUSE_DATA_SUCCESS: '@@auth/UPLOAD_WAREHOUSE_DATA_SUCCESS',
    UPLOAD_WAREHOUSE_DATA_ERROR: '@@auth/UPLOAD_WAREHOUSE_DATA_ERROR',

    STATE_EMPTY_FIRST: '@@auth/STATE_EMPTY_FIRST',
};
